import React, { useEffect } from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { usePrevious } from '../../Utils/Hooks';
import { withTheme, LightThemeColors } from '../Themes';

import styles from './HorizontalStepper.Styles';
import Step from './Step';
import Title from './Title';

const renderSteps = (theme, steps, activeIndex, onStepPress, isEditMode) => {
  return steps.map((step, index) => (
    <Step
      key={index}
      theme={theme}
      index={index}
      noOfSteps={steps.length}
      activeIndex={activeIndex}
      onStepPress={onStepPress}
      isEditMode={isEditMode}
      testID={FoundationTestKeys.horizontalStepperStep}
    />
  ));
};

const renderTitles = (theme, steps, activeIndex, onStepPress) => {
  return steps.map((step, index) => (
    <Title
      key={index}
      theme={theme}
      step={step}
      index={index}
      activeIndex={activeIndex}
      onStepPress={onStepPress}
      testID={FoundationTestKeys.horizontalStepperTitle}
    />
  ));
};

const HorizontalStepper = ({
  isEditMode,
  steps,
  activeStepIndex,
  onNextStep,
  onPreviousStep,
  onFinishSteps,
  style,
  theme,
  onStepPress,
  ...props
}) => {
  const prevActiveStepIndex = usePrevious(activeStepIndex);

  useEffect(() => {
    if (activeStepIndex === prevActiveStepIndex + 1) {
      _isFunction(onNextStep) && onNextStep();
    }
    if (activeStepIndex === prevActiveStepIndex - 1) {
      _isFunction(onPreviousStep) && onPreviousStep();
    }
    if (prevActiveStepIndex === steps.length - 1 && activeStepIndex === steps.length) {
      _isFunction(onFinishSteps) && onFinishSteps();
    }
  }, [activeStepIndex]);

  return (
    <View
      style={[styles.horizontalStepperStyle, style]}
      {...props}
      testID={FoundationTestKeys.horizontalStepperView}
    >
      <View
        style={styles.stepsContainerStyle}
        testID={FoundationTestKeys.horizontalStepperStepsContainerView}
      >
        {renderSteps(theme, steps, activeStepIndex, onStepPress, isEditMode)}
      </View>
      <View
        style={styles.titlesContainerStyle}
        testID={FoundationTestKeys.horizontalStepperTitlesContainerView}
      >
        {renderTitles(theme, steps, activeStepIndex, onStepPress)}
      </View>
    </View>
  );
};

HorizontalStepper.defaultProps = {
  activeStepIndex: 0,
  theme: LightThemeColors,
  isEditMode: false,
};

HorizontalStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      i18nKey: PropTypes.string.isRequired,
      accessibilityLabel: PropTypes.string,
    }),
  ),
  activeStepIndex: PropTypes.number,
  onNextStep: PropTypes.func,
  onPreviousStep: PropTypes.func,
  onFinishSteps: PropTypes.func,
  style: ViewPropTypes.style,
  theme: PropTypes.object,
  onStepPress: PropTypes.func,
  isEditMode: PropTypes.bool,
};

export default withTheme(HorizontalStepper);
